import chroma from "chroma-js";
import { Theme } from "@mui/material";

/**
 * Converte uma cor de DOMÍNIO (classe de ativo, tipo de upload, corretora) num
 * par bg/texto no estilo dos chips do sistema, legível nos dois temas.
 *
 * Por que isto existe: o DESIGN.md manda usar as cinco cores semânticas em chip
 * de STATUS — e status é o que o sistema quer padronizar. Mas classe de ativo e
 * tipo de upload não são status: são **categorias**, e o contador usa a cor para
 * bater o olho e distinguir FII de Opção numa tabela de 200 linhas. Colapsar 14
 * categorias em 4 cores destrói informação que o usuário usa para trabalhar.
 *
 * A saída: a cor da categoria vira tint de baixa opacidade (o mesmo peso visual
 * dos chips de status) e o texto vira a mesma matiz com luminância ajustada ao
 * tema. Preserva a distinção, sem o bloco de cor saturada que brigava com a
 * paleta quente da marca.
 *
 * Alvos de luminância derivados do WCAG: sobre `surface` dark (lum ~0.011) o
 * texto precisa de lum >= 0.22 para 4,5:1; sobre `surface` light (lum ~0.94),
 * de lum <= 0.17. O alvo real (0.10) e mais conservador: as categorias mais
 * escuras (#4030C9, #303030) so passam com essa margem.
 */
export function tintDeCor(cor: string, theme: Theme) {
  const escuro = theme.palette.mode === "dark";

  return {
    backgroundColor: chroma(cor)
      .alpha(escuro ? 0.22 : 0.16)
      .css(),
    color: escuro
      ? chroma(cor).luminance(0.45).hex()
      : chroma(cor).luminance(0.10).hex(),
  };
}
